import React, { useMemo } from 'react';

import DayJs from 'utils/Dayjs';
import { secondsToParts } from 'utils/Helpers';

import { useExamReviewStore } from 'store/exam/useExamReviewStore';

const Duration = () => {
	// Use exam's student store
	const [startedAt, endedAt] = useExamReviewStore(state => [state.take.startedAt, state.take.endedAt]);

	// Calculate how many seconds did exam take
	const seconds = useMemo(() => DayJs(endedAt).diff(startedAt, 's'), [startedAt, endedAt]);

	// Get exam's duration in usable format
	const duration = useMemo(() => secondsToParts(seconds), [seconds]);

	return (
		<div className="space-y-1">
			<div className="text-sm text-neutral-700 dark:text-neutral-200">Izpildes laiks</div>
			<div className="text-neutral-800 dark:text-white">{`${duration.days}d : ${duration.hours}h : ${duration.minutes}m : ${duration.seconds}s`}</div>
		</div>
	);
};

export default Duration;